const JoinFutureSection: React.FC = () => {
  return (
    <section className='max-w-[1112px] mx-auto lg:mt-[99px] mt-[148px]'>
      <hgroup className='flex items-center flex-col lg:gap-8 gap-6 px-[25px]'>
        <h2 className='text-center text-[28px]/9 lg:text-[52px]/[60px] font-semibold text-black dark:text-white'>Join The Future of DeFi </h2>
        <p className='text-base lg:text-lg/8 font-normal lg:font-medium text-primary-grey-150 dark:text-white-dark text-center'>Launch a Loan Marketplace in Minutes with NettyWorth's AI-Powered Protocol.</p>
        <a rel='noopener noreferrer' target='_blank' href='https://5vx6x80c2zf.typeform.com/to/No8JcIrA?typeform-source=docs.nettyworth.io' className='w-full md:w-[228px] h-[42px] rounded flex justify-center items-center !bg-primary font-medium text-base/5 !text-white hover:opacity-75 active:scale-95'>
          Request Form
        </a>
      </hgroup>
      {/* <div className='bg-sdk-footer bg-no-repeat  bg-cover'></div> */}
      <img className='hidden sm:block w-full mt-7 lg:mt-[88px]' src='/images/api-sdk-interfaces.png' alt='' />
      <img className='block sm:hidden w-full mt-7 lg:mt-[88px]' src='/images/api-sdk-interfaces-mobile.png' alt='' />
    </section>
  );
};

export default JoinFutureSection;
